import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { TENANT_FEATURES } from '../../core/services/tenant-feature.service';

const getClientIdFromSegments = (segments: UrlSegment[]): string | undefined => {
	const clientIndex = segments.findIndex((segment) => segment.path === 'client');

	if (clientIndex === -1) {
		return undefined;
	}

	return segments[clientIndex + 1]?.path;
};

const getClientAssignmentsRedirect = (segments: UrlSegment[]): string => {
	const clientId = getClientIdFromSegments(segments);

	if (!clientId) {
		return '/desk';
	}

	return `/desk/client/${clientId}/assignments`;
};

export const additionalAssignmentEnabledGuard: CanMatchFn = (_route, segments) => {
	const tenantFeatures = inject(TENANT_FEATURES);
	const router = inject(Router);

	if (tenantFeatures.additionalAssignmentEnabled()) {
		return true;
	}

	// Block the lazy route entirely and send the user back to the assignment overview.
	return router.parseUrl(getClientAssignmentsRedirect(segments));
};
